import { useNavigate } from "react-router-dom";
import { addRequest } from "./RecentSearchRequest";
import { useTranslation } from "react-i18next";

function SearchResults({ searchData }) {
  const navigate = useNavigate();

  const {t} = useTranslation();

  return (
    <>
      {searchData.length > 0 ? (
        searchData.map((item, index) => {
          return (
            <div
              key={index}
              className="profilePreviewDiv"
              onClick={() => {
                navigate("/" + item.username);
                addRequest(item.username);
              }}
            >
              {item.profile_image_url ? (
                <div className="profileImageDiv">
                  <img src={item.profile_image_url}></img>
                </div>
              ) : (
                <div className="emptyProfileImageDiv"></div>
              )}
              <div className="profilePreviewInfoDiv">
                <div className="fullnameDivInPreviewProfile">
                  <div>{item.fullname}</div>
                  {item.tick == true && <img src="/icons/green_tick.png"></img>}
                </div>

                <div className="usernameDiv">@{item.username}</div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="emptyDiv">
          <img src="/images/empty512.png"></img>
          <div className="emptyTitleDiv">{t("Empty")}</div>
        </div>
      )}
    </>
  );
}

export default SearchResults;
